// The five monster kinds of the NPC side (R2622, R2719, v2-the-deep.md
// §8.4): their classes in the order of `[[npc.monsters]]`, and the kind of
// a class. The kind indexes every monster table of the client
// (`render/monster-bodies.ts`, `render/monster-marks.ts`). A leaf with no
// words, so the combat layer can ask it without the string tables.

import { ShipClass } from '../gen/proto/aquaphobia';

/** The classes of the five kinds: Gulper, Murkhide, Quillback, Thrummer, Myriad. */
export const MONSTER_CLASSES: readonly ShipClass[] = [
  ShipClass.SHIP_CLASS_GULPER, ShipClass.SHIP_CLASS_MURKHIDE, ShipClass.SHIP_CLASS_QUILLBACK,
  ShipClass.SHIP_CLASS_THRUMMER, ShipClass.SHIP_CLASS_MYRIAD,
];

/** The kind of a class, 0 to 4, or -1 for a class that is no monster. */
export function monsterKindOf(cls: number): number {
  return MONSTER_CLASSES.indexOf(cls as ShipClass);
}
